// Utilidad compartida para TODAS las descargas de datos personales (2026-10 hardening).
// No usar fetch+blob directo en ningun componente nuevo: siempre pasar por secureExportDownload
// para garantizar disclaimer + cifrado + log del lado del backend (export_security.py).
let openModalFn = null;

export function registerSecureExportModal(fn) {
  openModalFn = fn;
}

export function secureExportDownload({ url, filename, method = 'GET', disclaimerText = null }) {
  return new Promise((resolve, reject) => {
    if (!openModalFn) {
      reject(new Error('El modal de descarga segura todavía no está listo, reintentá en un segundo'));
      return;
    }
    openModalFn({ url, filename, method, disclaimerText, resolve, reject });
  });
}
